import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import styles from '../styles.module.scss';
import { Radio } from '../../Input/Radio/Radio';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';
import { addDeskingDefaults } from '../defaults';

export const DealerLaunchMaximumResidual: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({
    defaultValues: addDeskingDefaults(dealer),
  });
  return (
    <DealerLaunchFormCardLayout
      className={styles.widgetsStep}
      form={form}
      title="Tell Us About How Your Payments Are Configured"
      subTitle=""
      cardTitle="Should maximum residualized MSRP (MRM) ever factor into lease deals?"
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <Radio
        className="flex-column"
        name="desking.ignoreMRM"
        options={[
          {
            label: 'Yes',
            value: false,
          },
          {
            label: 'No',
            value: true,
          },
        ]}
        form={form}
        validation={{
          validate: (val: any) => {
            if (typeof val !== 'boolean') return 'A selection is required';
            return true;
          },
        }}
      />
    </DealerLaunchFormCardLayout>
  );
};
